/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import type { ComponentProps, ReactNode } from "react";
import { forwardRef } from "react";

import type { ThemeType } from "../../../../global/emotion";
import {
  colors,
  fontSizes,
  numericPixels,
  useTheme,
} from "../../../../global/emotion";

const containerStyle: Interpolation = {
  display: "flex",
  flexDirection: "row",
};
const inputStyle: Interpolation<ThemeType> = (theme) => ({
  background: colors.transparent,
  borderWidth: numericPixels[0],
  color: theme.semanticColors.primary,
  flexGrow: 1,
  fontSize: fontSizes.bodyXL,
  outline: "none",
});
const inputDarkStyle: Interpolation = {
  "::-webkit-calendar-picker-indicator": {
    filter: "invert(1)",
  },
};

type AuthTextInputProps = ComponentProps<"input"> & {
  button?: ReactNode;
};

export const AuthTextInput = forwardRef<HTMLInputElement, AuthTextInputProps>(
  ({ button, ...props }, ref) => {
    const { renderedTheme } = useTheme();
    return (
      <div css={containerStyle}>
        <input
          css={[inputStyle, renderedTheme === "dark" && inputDarkStyle]}
          {...props}
          ref={ref}
        />
        {button}
      </div>
    );
  },
);
